import React, { Component } from "react";
import {
    Card,
    Button,
    CardBody,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
    Col,
    ModalFooter,
    CardFooter,
    Progress,
    ButtonGroup,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Spinner,
    UncontrolledTooltip,
    CardHeader,
    Label
} from "reactstrap";
import { connect } from "react-redux";
import {
    destoryKasms,
    getUserKasms,
    createKasms,
    getStatusKasms,
    updateKeepalive,
    getUserImages,
    getViewedKasms
} from "../../../../actions/actionDashboard";
import { logout } from "../../../../actions/actionLogin";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../../../components/LoadingSpinner/index";
import Proptypes from "prop-types";
import Select from "react-select";
import "react-select/dist/react-select.css";
import moment from "moment";
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';
import {getUserUsageSummary} from "../../../../actions/actionUser";

var intervalID;

class Listkasms extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            deleteConfirm: null,
            videoQuality: 1,
            kasmId: "",
            currentId: null,
            url: "",
            activeCard: false,
            loader: false,
            attempt: 0,
            progressBarValues: [],
            pointPresenceValues: [],
            persistentProfileValues: [],
            refreshing: false,
            showTips: true,
            toggleControlPanel: false,
            createClicked: false,
            createResumeClicked: false,
            disconnect: false,
            deleteClicked: false
        };
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.destoryKasms = this.destoryKasms.bind(this);
        this.initializePointsofPresence = this.initializePointsofPresence.bind(this);
        this.initializePersistentProfile = this.initializePersistentProfile.bind(this);
        this.renderLiveKasms = this.renderLiveKasms.bind(this);
        this.renderAvailableKasms = this.renderAvailableKasms.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleCard = this.toggleCard.bind(this); 
        this.createKasm = this.createKasm.bind(this);
        this.handlePointPresenceDropDown = this.handlePointPresenceDropDown.bind(this);
        this.handlePersistentProfileDropDown = this.handlePersistentProfileDropDown.bind(this);
        this.handleResumeKasm = this.handleResumeKasm.bind(this);
        this.stateFunctionUrl = this.stateFunctionUrl.bind(this);
        this.toggleDrop = this.toggleDrop.bind(this);
        this.updateProgressBarValue = this.updateProgressBarValue.bind(this);
        this.handleDisconnect = this.handleDisconnect.bind(this);
        this.defaultThumb = this.defaultThumb.bind(this);
        this.renderJoinedKasms = this.renderJoinedKasms.bind(this);
    }

    defaultThumb(e) {
        e.target.src = 'img/favicon.png';
    }

    stateFunctionUrl(){
        this.setState({url: "" });
    }

    deleteConfirm(event, kasmId){
        event.stopPropagation();
        this.setState({modal: !this.state.modal,
            kasmId: kasmId });
    }

    handleDisconnect() {
        this.stateFunctionUrl();
        this.setState({
            attempt: 0,
            showTips: false,
            disconnect: true
        });
        this.delay_check_load();
    }
    
    handleResumeKasm(kasm_id) {
        const userInfo = JSON.parse(window.localStorage.user_info);
        const {getstatuskasmsError} = this.props;
        this.setState({kasmId: kasm_id, createResumeClicked: true});
        this.props.getStatusKasms(kasm_id).
            then(() => this.props.history.push('/kasm/' + kasm_id)).
            catch(() => this.setState({kasmId: kasm_id, createResumeClicked: false}),("Unable to Fetch API Data"));
    }

    destoryKasms(){
        this.setState({
            deleteClicked: true
        });
        this.props.destoryKasms(this.state.kasmId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    toggle(){
        this.setState({modal: !this.state.modal});
    }

    handlePointPresenceDropDown(imageId, value){
        let pointPresenceValues = this.state.pointPresenceValues;
        pointPresenceValues.map(image => {
            if(image.imageId === imageId) {
                image.value =  value; 
            }
        });
        this.setState({pointPresenceValues});
    }

    handlePersistentProfileDropDown(imageId, value){
        let persistentProfileValues = this.state.persistentProfileValues;
        persistentProfileValues.map(image => {
            if(image.imageId === imageId) {
                image.value =  value;
            }
        });
        this.setState({persistentProfileValues});
    }

    toggleCard(){
        this.state({card3: !this.state.card3});
    }

    handleDeleteSuccess(){
        const {destoryKasmsErrorMessage} = this.props;
        if(destoryKasmsErrorMessage) {
            NotificationManager.error(destoryKasmsErrorMessage,"Delete Kasm", 3000);
        }
        else{
            const userInfo = JSON.parse(window.localStorage.user_info);
            const payload_data = {
                "token": userInfo.token,
                "username": userInfo.username
            };
            this.setState({modal: false, deleteClicked: false});
            this.props.getUserKasms(payload_data);
            this.props.getUserUsageSummary();
            NotificationManager.success("Successfully Deleted Kasm","Delete Kasm", 3000);
        }
    }

    createKasm(imageId, available) {
        if (!available) {
            NotificationManager.error("This image is not currently available. Agent may still be downloading Image.","Image Loading",3000);
            return;
        }

        this.setState({currentId: imageId,
                        createClicked: true});
        let currentImage = this.state.pointPresenceValues.find(image => image.imageId === imageId);
        let currentImage2 = this.state.persistentProfileValues.find(image => image.imageId === imageId);
        let persistent_profile_mode = currentImage2 && currentImage2.value ? currentImage2.value.value : "";
        window.localStorage.setItem('persistent_profile_mode', persistent_profile_mode);
        this.props.createKasms({
            point_of_presence: currentImage && currentImage.value ? currentImage.value.value : "",
            persistent_profile_mode: persistent_profile_mode,
            image_id: imageId,
            x_res: window.innerWidth,
            y_res: window.innerHeight
        }).
        then(() => {
            this.handleCreateSuccess();
        }).
        catch(() =>this.handleCreateError());
    }   

    handleDeleteError(){
        const {deleteKasmsError} = this.props;
        this.setState({ createClicked: false, deleteClicked: false });
        if(deleteKasmsError){
            NotificationManager.error(deleteKasmsError,"Delete Kasm", 3000);
        }
        else{
            NotificationManager.error("Failed to Delete Kasm","Delete Kasm", 3000);
        }
    }

    handleCreateError(){
        const {createKasmsError, errorCreateMessageDetail} = this.props;
        this.setState({ createClicked: false });
        if(createKasmsError){
            NotificationManager.error(createKasmsError,"Create Kasm", 3000);
            if (errorCreateMessageDetail) {
                console.error(errorCreateMessageDetail);
            }
        }
        else{
            NotificationManager.error("Gateway Time-out","Create Kasm", 3000);
        }
    }

    handleCreateSuccess(){
        const {errorCreateMessage, errorCreateMessageDetail} = this.props;

        if(errorCreateMessage){
            NotificationManager.error(errorCreateMessage,"Create Kasm", 3000);
            this.setState({ createClicked: false });
            if (errorCreateMessageDetail) {
                console.error(errorCreateMessageDetail);
            }
        }
        else{
            NotificationManager.success("Kasm Created", "Successfully Created Kasm");
            const { createdKasms, getStatusKasms }= this.props;
            if(createdKasms.kasm_id) {
                this.props.history.push('/kasm/' + createdKasms.kasm_id);
            }
        }
    }

    toggleDrop(index){
        index ===  this.state.activeCard ?  this.setState({activeCard: null}) : this.setState({activeCard: index});
    }

    updateProgressBarValue(){
        let dataCopy = [];
        const self = this;
        this.props.liveKasms && this.props.liveKasms.length > 0 && this.props.liveKasms.map((kasm) => {
            const now = new Date();
            const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
            const start_date =  new Date(kasm.start_date);
            const end_date = new Date(kasm.expiration_date);
            let seconds = (end_date - start_date) / 1000;
            dataCopy.push({"current_time": ((utc - start_date) / 1000), "expiry_time": seconds});
        });

        intervalID = setInterval(function () {
            dataCopy.map((item, index) => {
                dataCopy[index].current_time = item.current_time + 1;
            });
            // FIXME KASM-365. Setting the state causes the full page to be re-rendered
            self.setState({progressBarValues: dataCopy});
        }, 1000);
    }

    initializePointsofPresence(availableKasms) {
        let pointPresenceValues = [];
        availableKasms.map(kasm=> (
            pointPresenceValues.push({"imageId": kasm.image_id, "value": ""})
        ));
        this.setState({ pointPresenceValues });
    }

    initializePersistentProfile(availableKasms) {
        let persistentProfileValues = [];

        let cached_persistent_profile_mode = window.localStorage.getItem('persistent_profile_mode');
        if (!cached_persistent_profile_mode || ( cached_persistent_profile_mode && cached_persistent_profile_mode != "Disabled")){
            cached_persistent_profile_mode = "Enabled"
        }

        availableKasms.map(kasm=> (
            persistentProfileValues.push({"imageId": kasm.image_id, "value": {"key" : cached_persistent_profile_mode, "value": cached_persistent_profile_mode}})
        ));
        this.setState({ persistentProfileValues });
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(this.props.availableKasms !== nextProps.availableKasms && nextProps.availableKasms && nextProps.availableKasms.length > 0){
            this.initializePointsofPresence(nextProps.availableKasms);
            this.initializePersistentProfile(nextProps.availableKasms);
        }
    }

    componentWillUnmount() {
        //Stops memory leak from setInterval calls
        if (intervalID) {
            window.clearInterval(intervalID);
        }
    }

    componentDidMount(){
        if (window.localStorage.getItem("joined_kasms")) {
            let viewed_kasms = JSON.parse(window.localStorage.getItem("joined_kasms")).kasms;
            this.props.getViewedKasms(viewed_kasms);
        }
        this.props.availableKasms && this.initializePointsofPresence(this.props.availableKasms);
        this.props.availableKasms && this.initializePersistentProfile(this.props.availableKasms);
        this.updateProgressBarValue(this.props.liveKasms);
        this.props.getUserUsageSummary();
    }
   
    renderLiveKasms(){
        if(this.state.loader){
            return(<div><div className={this.props.statusKasms && this.props.statusKasms.is_persistent_profile ? "loaderStatus" : ""}>Loading Persistent Profile. This may take a moment...</div><div className="loaderBg"> <LoadingSpinner /></div></div>);
        }
        const {liveKasms} = this.props;
        let doRefresh = false;

        // We want to refresh the Live Kasms data every so often if there is a delete_pending Kams. it should get cleaned up shortly after.
        if (liveKasms && liveKasms.length > 0){
            for (let i in liveKasms){
                if (liveKasms[i].operational_status === "delete_pending" ){
                    doRefresh = true;
                }
            }
        }
        if (doRefresh && ! this.state.refreshing){
            this.state.refreshing=true;
            setTimeout(() => {

                const userInfo = JSON.parse(window.localStorage.user_info);
                const payload_data = {
                    "token": userInfo.token,
                    "username": userInfo.username
                };
                this.props.getUserKasms(payload_data);
                this.state.refreshing = false;
                }
                , 10000 );
        }

        return(
            <div className="panelContainer">
                <div className="panelContainerHeading">
                    <i className="fa fa-align-justify"></i> <strong>Live Kasms</strong>
                </div>
                { liveKasms && liveKasms.length > 0 ?   
                    <div className="panelContainerBody">
                        <Row>                     
                            <Col xs="12">
                                <div className="row kasm_image">
                                    { liveKasms.sort(function(a,b){return a.kasm_id.localeCompare(b.kasm_id)}).map((kasm, index) =>
                                        <Col md="6" key={index}>
                                            <Card style={{'maxWidth':'500px'}} onClick={() => {this.handleResumeKasm(kasm.kasm_id)}} >
                                                <div className="listkasm-active">
                                                    <div className="undo-background">
                                                    <CardBody  className={kasm.operational_status == "delete_pending" ?  "text-white bg-danger" : "text-white bg-primary"}>
                                                        {kasm.image.image_src && kasm.image.image_src != "" ?
                                                            <img onError={e => e.target.style.display = 'none'} className="livethumbnails float-left" src={ kasm.image.image_src }/> :
                                                            <i className="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left" />
                                                        }

                                                        <h3 className= "kasm_heading" >Kasm ID: {kasm.kasm_id.substring(0, 6) } </h3>
                                                        <ButtonGroup id={kasm.kasm_id} className="float-right mar-top-3 listkasm-delete">
                                                            <p onClick={(event) => this.deleteConfirm(event, kasm.kasm_id)} >
                                                                <i name="delete" className="fa fa-close" />
                                                            </p>
                                                        </ButtonGroup>
                                                        <div className= "kasm_friendly">Image : {kasm.image.friendly_name}</div>
                                                        <div className = "image_first_item"><span>Status:</span> {kasm.operational_status}</div>
                                                        <div className = "image_last_item"><span>Created:</span> { moment.utc(kasm.start_date).local().format("L h:mm A")}</div>
                                                        <div className = "image_last_item"><span>Last Accessed:</span> { moment.utc(kasm.keepalive_date).local().format("L h:mm A")}</div>
                                                        <div className = "image_last_item"><span>Expires On:</span> { moment.utc(kasm.expiration_date).local().format("L h:mm A")}</div>
                                                        { kasm.point_of_presence ? <div className="point_of_presence"><span>Point of Presence: </span> {kasm.point_of_presence}</div> : <div className="point_of_presence">&nbsp;</div> }
                                                        { kasm.is_persistent_profile ? <div className="is_point_of_presence"><span>Persistent Profile: </span> {String(kasm.persistent_profile_mode)}</div> : <div className="is_point_of_presence">&nbsp;</div> }

                                                        { this.state.progressBarValues[index] ?
                                                            <Progress className="progress_kasm" value={this.state.progressBarValues[index].current_time} min={0} max={this.state.progressBarValues[index].expiry_time} /> 
                                                            : ""
                                                        }
                                                    </CardBody>
                                                    <CardFooter className = "kasm_footer">
                                                        <div className= "brand-card-body">
                                                            <Col sm="6" className="brdr-rght">
                                                                <div className="text-value">
                                                                    { moment.utc(kasm.current_time).diff(moment.utc(kasm.start_date), "days" ) ?
                                                                      moment.utc(kasm.current_time).diff(moment.utc(kasm.start_date), "days" ) + "d " :
                                                                      ""
                                                                    }
                                                                    { moment.utc(kasm.current_time).diff(moment.utc(kasm.start_date), "hours" ) ?
                                                                      moment.utc(moment.utc(kasm.current_time).diff(moment.utc(kasm.start_date), "hh:mm:ss")).format("HH[h] ") :
                                                                      ""
                                                                    }
                                                                    {moment.utc(moment.utc(kasm.current_time).diff(moment.utc(kasm.start_date), "hh:mm:ss")).format("mm[m]")}
                                                                </div>
                                                                <div className="text-uppercase text-muted small">UPTIME</div> 
                                                            </Col>
                                                            <Col sm="6">
                                                                <div className="text-value">
                                                                    {(moment.utc(kasm.expiration_date) < moment.utc(kasm.current_time)) ?
                                                                        <div style ={{"color":"red"}}>Expired</div>
                                                                        :
                                                                         (moment.utc(kasm.expiration_date).diff(moment.utc(kasm.current_time), "minutes" ) < 60 ) ?
                                                                            <div style ={{"color":"red"}}>
                                                                                {moment.utc(moment.utc(kasm.expiration_date).diff(moment.utc(kasm.current_time), "hh mm ss" )).format("mm[m]")}
                                                                            </div>
                                                                            :
                                                                            <div>
                                                                                { moment.utc(kasm.expiration_date).diff(moment.utc(kasm.current_time), "days" ) ?
                                                                                  moment.utc(kasm.expiration_date).diff(moment.utc(kasm.current_time), "days" ) + "d " :
                                                                                  ""
                                                                                }
                                                                                { moment.utc(kasm.expiration_date).diff(moment.utc(kasm.current_time), "hours" ) ?
                                                                                  moment.utc(moment.utc(kasm.expiration_date).diff(moment.utc(kasm.current_time), "hh:mm:ss")).format("HH[h] ") :
                                                                                  ""
                                                                                }
                                                                                {moment.utc(moment.utc(kasm.expiration_date).diff(moment.utc(kasm.current_time), "hh:mm:ss")).format("mm[m]")}
                                                                            </div>
                                                                    }
                                                                </div>
                                                                <div className="text-uppercase text-muted small">EXPIRATION</div>
                                                            </Col>
                                                        </div>
                                                    </CardFooter>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>
                                    )}
                                </div> 
                            </Col>  
                        </Row> 
                    </div> : <div className="panelContainerBody"></div>   }
            </div>
        );
    } 

    renderAvailableKasms(){
        if(this.state.loader){
            return(<div className="loaderBg"> <LoadingSpinner /></div>);
        }
        const {availableKasms} = this.props;
        const {pointPresenceValues} = this.state;
        const {persistentProfileValues} = this.state;
        let keysSorted;
        return(
            <div className="panelContainer">
                <div className="panelContainerHeading">
                    <i className="fa fa-align-justify"></i> <strong>Available Kasm Images</strong>
                </div>
                { availableKasms && availableKasms.length > 0 ?
                    <div className="panelContainerBody">
                        <Row>                     
                            <Col xs="12">
                                <div className="row ">
                                    {
                                      availableKasms.sort(function(a,b){return a.friendly_name.localeCompare(b.friendly_name)}).map((kasm, index) =>
                                    {
                                        let currentImage = pointPresenceValues && pointPresenceValues.length > 0 ? pointPresenceValues.find(image => image.imageId === kasm.image_id) : "";
                                        let currentImage2 = persistentProfileValues && persistentProfileValues.length > 0 ? persistentProfileValues.find(image => image.imageId === kasm.image_id) : null;
                                        return(
                                            <Col md="5" key={index} className="kasmCardBottom"> 
                                                <Row>
                                                    <Col md="12">
                                                        <Row className="show-grid kasmCardContent">

                                                            <Col xs={5} sm={4} md={3} lg={4} xl={3}>
                                                                {kasm.image_src && kasm.image_src != "" ?
                                                                    <img onError={this.defaultThumb} className="thumbnails float-left" src={ kasm.image_src }/> :
                                                                    <i className="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left" />
                                                                }
                                                            </Col>
                                                            <Col xs={7} sm={8} md={9} lg={8} xl={9} className="settingPad ">
                                                                <h5 className = "mb-0 text-info">{kasm.friendly_name}</h5>
                                                                {kasm.available  ?
                                                                    "" :
                                                                    <div>
                                                                        <span className="float-right" ><i id={kasm.friendly_name.replace(/\s+/g, '')} className="fa fa-exclamation-triangle text-danger font-2xl" />
                                                                        <UncontrolledTooltip target={kasm.friendly_name.replace(/\s+/g, '')} >
                                                                            Image is not on agent. Agent may still be downloading. Refresh page for update.
                                                                        </UncontrolledTooltip>
                                                                        </span>
                                                                    </div>}

                                                                <div className="text-muted">{kasm.description}</div>
                                                            </Col>

                                                        </Row>
                                                        <Row>
                                                            { kasm.persistent_profile_settings.length > 0 ?
                                                                <Col xs={11} sm={11} lg={10} xl={5} className="ml-3 pb-2">
                                                                    <div >
                                                                        <span className="text-muted">Persistent Profile</span>
                                                                        <Select
                                                                            id={"persistent_profile_" + kasm.image_id}
                                                                            key={kasm.image_id}
                                                                            value={currentImage2 ? currentImage2.value : ""}
                                                                            options={kasm.persistent_profile_settings.map(val=> {return {key: val, value: val};})}
                                                                            valueKey="value"
                                                                            labelKey="key"
                                                                            name="image_id"
                                                                            onChange={this.handlePersistentProfileDropDown.bind(this, kasm.image_id)}
                                                                        />
                                                                    </div>
                                                                </Col>: ""
                                                            }

                                                            { kasm.points_of_presence.length > 0 ?
                                                                <Col xs={11} sm={11} lg={10} xl={5} className="ml-3 pb-2">
                                                                    <div className="">
                                                                        <span className="text-muted">Point of Presence</span>
                                                                        <Select
                                                                            id={kasm.image_id}
                                                                            key={kasm.image_id}
                                                                            value={currentImage ? currentImage.value : ""}
                                                                            options={kasm.points_of_presence.map(val=> {return {key: val, value: val};})}
                                                                            valueKey="value"
                                                                            labelKey="key"
                                                                            name="image_id"
                                                                            onChange={this.handlePointPresenceDropDown.bind(this, kasm.image_id)}
                                                                        />
                                                                    </div>
                                                                </Col>: ""
                                                            }

                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row className="kasmCardFooter">
                                                    <Col md="12">
                                                        <div>
                                                         {this.state.createClicked ? <div> {(this.state.currentId === kasm.image_id ? <Spinner color="primary" /> : <Button color="primary" className="btn-block" style = {{"cursor" : "pointer"}} disabled={true} >Create </Button>  )} </div> :
                                                         <Button color="primary" className="btn-block" style = {{"cursor" : "pointer"}} onClick={this.createKasm.bind(this, kasm.image_id, kasm.available)}  disabled={kasm.available ? (this.props.createKasmsLoading && this.state.currentId === kasm.image_id) : false}> Create </Button>}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        );
                                    }
                                    )
                                    }
                                </div>
                            </Col>  
                        </Row>
                    </div>  : <div className="panelContainerBody">No Images Found!</div> }
            </div> 
        );
    }

    renderJoinedKasms() {
        const { viewedKasms, viewKasmsLoading} = this.props;
        if (viewKasmsLoading) {
            return (
                <div>loading...</div>
            )
        }
        let recent_kasms = viewedKasms && viewedKasms.map((kasm, i) => {
           return (
               <Col md="5" xl={3} className="join-shared-kasm" key={i}>
                   <Link style={{color:'black'}} to={'/join/' + kasm.share_id}>
                        <Card className={"join-shared-kasm-card"}>
                            <Row>
                                <div>
                                   {kasm.image_src && kasm.image_src !== "" ?
                                       <img onError={this.defaultThumb} className="thumbnails float-left" src={ kasm.image_src }/> :
                                       <i className="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left" />
                                   }
                                </div>
                                <div style={{paddingLeft:'10px'}}>
                                   <h5 className="text-info"> {kasm.image}</h5>
                                   Host: {kasm.user} <br />
                                   Share ID: {kasm.share_id}
                                </div>
                            </Row>
                        </Card>
                   </Link>
               </Col>
           )
        });
        return (
            <div className="panelContainer">
                <div className="panelContainerHeading">
                    <i className="fa fa-align-justify" /> <strong>Recently Viewed Kasms</strong>
                </div>
                <div className="panelContainerBody">
                    <Row>
                        {recent_kasms}
                    </Row>
                </div>
            </div>
        );
    }

    render(){
        const { usageSummary} = this.props;
        let usage_duration = '';
        let usage_limit_start_date = '';
        let usage_limit_next_start_date = '';
        let color = 'info';
        let interval = '';
        let interval_translation = {
            'total': '',
            'monthly': 'This Month',
            'weekly': 'This Week',
            'daily': 'Today'
        };
        if (usageSummary && usageSummary.usage_limit_remaining) {
            let percent = 0;
            usage_limit_start_date = moment.utc(usageSummary.usage_limit_start_date).local().format("MM/DD/YY HH:mm");
            usage_limit_next_start_date = moment.utc(usageSummary.usage_limit_next_start_date).local().format("MM/DD/YY HH:mm");
            if (usageSummary.usage_limit_remaining > 0){
                percent = 100 - ((usageSummary.usage_limit_remaining / usageSummary.usage_limit_hours) * 100);
            } else {
                percent = 100
            }

            if (percent > 90) {
                color = 'danger';
            } else if (percent > 70) {
                color = 'warning';
            } else {
                color = 'info';
            }
        }
        if (usageSummary) {
            interval = interval_translation[usageSummary.usage_limit_interval];
            if (usageSummary.usage_limit_type === "per_group"){
                interval+= ". Usage is shared with other group members."
            }
        }
        return (
            <div>
                <div>
                    <Row>
                        <Col sm>
                            {usageSummary && usageSummary.group_metadata && usageSummary.group_metadata.subscription_name ?
                                <React.Fragment>
                                    <Card>
                                        <CardHeader>
                                            <img onError={this.defaultThumb} className="livethumbnails float-left" src={ usageSummary.group_metadata.subscription_thumbnail }/><strong style={{'verticalAlign':'-webkit-baseline-middle'}}>{usageSummary.group_metadata.subscription_name}</strong>
                                        </CardHeader>
                                        <CardBody>
                                            {usageSummary.group_metadata.subscription_description}
                                        </CardBody>

                                            {
                                                usageSummary.group_metadata.subscription_link && usageSummary.group_metadata.subscription_link_name ?
                                                    <CardFooter className = "kasm_footer">
                                                        <a href={usageSummary.group_metadata.subscription_link}
                                                           rel="noopener noreferrer"
                                                           target="_blank"
                                                        >
                                                            {usageSummary.group_metadata.subscription_link_name}
                                                        </a>
                                                    </CardFooter>
                                                :
                                                ""
                                            }

                                    </Card>
                                </React.Fragment>
                                : ""
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col sm>
                            {usageSummary && usageSummary.usage_limit ?
                                <React.Fragment>
                                    <Card>
                                        <CardHeader>
                                            <i className="fa fa-clock-o"></i><strong>Usage Summary</strong>
                                        </CardHeader>
                                        <CardBody>
                                           <Label className="standalone-label"> <u>{usageSummary.usage_limit_remaining && usageSummary.usage_limit_remaining < 0 ?
                                                usageSummary.usage_limit_hours :
                                                (usageSummary.usage_limit_hours - usageSummary.usage_limit_remaining).toFixed(1)
                                           }</u>  of <u>{usageSummary.usage_limit_hours}</u> Hours Used <u>{interval}</u>
                                           </Label>
                                            <Progress striped
                                                      color={color}
                                                      value={usageSummary.usage_limit_hours - usageSummary.usage_limit_remaining}
                                                      max={usageSummary.usage_limit_hours}  >
                                            </Progress>
                                            {usageSummary && usageSummary.usage_limit_interval != "total" ?
                                                <Label className="standalone-label">{usage_limit_start_date}
                                                    -> {usage_limit_next_start_date}</Label>
                                                :
                                                ""
                                            }
                                        </CardBody>
                                    </Card>
                                </React.Fragment>
                                : ""
                            }
                        </Col>
                    </Row>
                    <div>{this.renderLiveKasms()}</div>
                    <div>{this.renderJoinedKasms()}</div>
                    <div>{this.renderAvailableKasms()}</div>
                    <Modal
                        isOpen={this.state.modal}
                        toggle={this.deleteConfirm}
                        className={this.props.className}
                    >
                        <ModalHeader toggle={this.deleteConfirm}>
                            Delete Kasm <i className="fa fa-bomb" aria-hidden="true"></i>
                        </ModalHeader>
                        <ModalBody>
                            Confirm Delete Kasms ?
                        </ModalBody>
                        <ModalFooter>
                            { this.state.deleteClicked ?
                                    <Spinner size="sm" color={"danger"} />
                                :
                                <Button  onClick={this.destoryKasms} disabled={this.props.destoryKasmsLoading} size="sm" color="danger">
                                    <i className="fa fa-trash"></i> Delete
                                </Button> }
                            <Button  onClick={this.toggle} size="sm" color="basic">
                                <i className="fa fa-ban"></i> Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        ); 
    }
}

Listkasms.propTypes = {
    destoryKasms: Proptypes.func.isRequired,
    logout: Proptypes.func.isRequired,
    getUserKasms: Proptypes.func.isRequired,
    createKasms: Proptypes.func.isRequired,
    updateKeepalive: Proptypes.func.isRequired,
    getStatusKasms: Proptypes.func.isRequired,
    destoryKasmsErrorMessage: Proptypes.object,
    liveKasms: Proptypes.array,
    availableKasms: Proptypes.array,
    deleteKasmsError: Proptypes.object,
    errorCreateMessage: Proptypes.string,
    errorCreateMessageDetail: Proptypes.string,
    createKasmsError: Proptypes.string,
    createdKasms: Proptypes.object,
    statusKasms: Proptypes.object,
    getstatuskasmsError: Proptypes.object,
    errorStatusKasmsMessage: Proptypes.object,
    type: Proptypes.string,
    getstatuskasmsLoading:  Proptypes.bool,
    destoryKasmsLoading: Proptypes.func,
    className: Proptypes.object,
    createKasmsLoading: Proptypes.bool,
    history: Proptypes.object.isRequired,
};

Listkasms= withRouter(Listkasms);

export default connect(state => 
    ({
        errorCreateMessage: state.dashboard.errorCreateMessage || null,
        errorCreateMessageDetail: state.dashboard.errorCreateMessageDetail || null,
        deleteKasmsError: state.dashboard.deleteKasmsError || null,
        getstatuskasmsLoading: state.dashboard.getstatuskasmsLoading || null,
        destoryKasmsErrorMessage: state.dashboard.destoryKasmsErrorMessage || null,
        createKasmsLoading: state.dashboard.createKasmsLoading || false,
        destoryKasmsLoading: state.dashboard.destoryKasmsLoading || null,
        createKasmsError: state.dashboard.createKasmsError || null,
        statusKasms: state.dashboard.statusKasms || null,
        getstatuskasmsError: state.dashboard.getstatuskasmsError || null,
        errorStatusKasmsMessage: state.dashboard.errorStatusKasmsMessage || null,
        fetchedKasms: state.dashboard.kasms || [],
        createdKasms: state.dashboard.createdKasms || null,
        availableKasms: state.dashboard.availableKasms,
        liveKasms: state.dashboard.liveKasms,
        viewedKasms: state.dashboard.viewedKasms,
        viewKasmsLoading: state.dashboard.viewKasmsLoading,
        usageSummary: state.user.usageSummary
    }),
dispatch => 
    ({  
        logout: (logout_data) => dispatch(logout(logout_data)),
        imageFunc: (payload_data) => dispatch(getUserImages(payload_data)),
        destoryKasms: (data) => dispatch(destoryKasms(data)),
        getUserKasms: (payload_data) => dispatch(getUserKasms(payload_data)),
        createKasms: (data) => dispatch(createKasms(data)),
        updateKeepalive: (data) => dispatch(updateKeepalive(data)),
        getStatusKasms: (data) => dispatch(getStatusKasms(data)),
        getViewedKasms: (data) => dispatch(getViewedKasms(data)),
        getUserUsageSummary: (payload_data) => dispatch(getUserUsageSummary())
    }))(Listkasms);



// WEBPACK FOOTER //
// ./src/views/User/UserDashboard/ListKasms/index.js